import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../app/store/utils/baseQueryWithReauth';

type ICompanyQueryParams = {
  tenantID: string;
  token: string;
};

export const configurationApi = createApi({
  reducerPath: 'configurationApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Configuration', 'Company'],
  endpoints: build => ({
    getConfiguration: build.query<any, void>({
      transformResponse: (response: { data: any }) => response.data,
      query: () => ({
        url: '/public/configuration',
        method: 'GET',
      }),
      providesTags: ['Configuration'],
    }),
    getCompany: build.query<any, ICompanyQueryParams>({
      transformResponse: (response: { data: any }) => response.data,
      query: ({ tenantID, token }) => ({
        url: `/public/company/${tenantID}`,
        method: 'GET',
        params: token ? { token } : undefined,
      }),
      providesTags: ['Company'],
    }),
    fetchConfiguration: build.mutation<any, void>({
      transformResponse: (response: { data: any }) => response.data,
      query: () => ({
        url: '/public/configuration',
        method: 'GET',
      }),
      invalidatesTags: ['Configuration'],
    }),
    fetchCompany: build.mutation<any, ICompanyQueryParams>({
      transformResponse: (response: { data: any }) => response.data,
      query: ({ tenantID, token }) => ({
        url: `/public/company/${tenantID}`,
        method: 'GET',
        params: token ? { token } : undefined,
      }),
      invalidatesTags: ['Company'],
    }),
  }),
});

export const {
  useGetConfigurationQuery,
  useGetCompanyQuery,
  useFetchConfigurationMutation,
  useFetchCompanyMutation,
} = configurationApi;
